import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { OpenDialogService } from 'common/util.pickers/module'
import { MessageBoxService } from 'common/util/module'
import { JobInputTypeEnum } from 'elements-sdk'

@Component({
  selector: 'task-input',
  templateUrl: './taskInput.component.pug',
})
export class TaskInputComponent {
  @Input() args: Record<string, any>
  @Input() vars?: any[] // TODO
  @Input() suggestVariableInput = false
  @Input() inputType: JobInputTypeEnum
  @Output() enter = new EventEmitter<void>()

  constructor (
    private openDialog: OpenDialogService,
    private messageBox: MessageBoxService,
    private translate: TranslateService,
  ) { }

  ngOnInit () {
    if (this.inputType === JobInputTypeEnum.Dirs || this.inputType === JobInputTypeEnum.Paths) {
      this.args.input ??= []
    }
  }

  async showAdd () {
    const path = await this.openDialog.show({
      globMode: ['paths', 'path'].includes(this.inputType),
    }).catch(() => null)
    if (!path) {
      return
    }
    this.addInput(path)
  }

  addInputVariable () {
    this.addInput('{{input}}')
  }

  addVariable (v: any) {
    this.addInput('{{' + v.key + '}}')
  }

  addInput (v: string) {
    if (!this.args.input) {
      this.args.input = []
    }
    if (!this.args.input.includes(v)) {
      this.args.input = [...this.args.input, v]
    }
  }

  async editInput (input: string) {
    const index = this.args.input.indexOf(input)
    const msg = await this.messageBox.prompt({
      prompt: this.translate.instant('Edit item'),
      value: input,
    }).catch(() => null)
    if (!msg) {
      return
    }
    if (!this.args.input.includes(msg.value)) {
      this.args.input[index] = msg.value
      this.args.input = this.args.input.slice()
    }
  }

  removeInput (input: string) {
    this.args.input = this.args.input.filter(i => i !== input)
  }
}
